import { FC } from 'react';

const IllustrationChat: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="81"
    fill="none"
    viewBox="0 0 80 81"
  >
    <path
      fill="#1D1D1D"
      d="M59.63 72.5q1.226 0 1.932-.806.687-.805.687-2.154V65.1h1.077q2.638 0 4.588-1.068t3.027-3.073Q72 58.955 72 56.144v-14.67q0-2.81-1.04-4.815a7.26 7.26 0 0 0-3.046-3.072Q65.927 32.5 63.122 32.5h-24.35q-2.822 0-4.791 1.087a7.15 7.15 0 0 0-3.028 3.072q-1.058 2.005-1.058 4.815v14.67q0 2.811 1.058 4.815a7.15 7.15 0 0 0 3.028 3.073q1.968 1.068 4.792 1.068h11.144l6.314 5.62q1.04.918 1.802 1.35a3.13 3.13 0 0 0 1.597.43m-1.003-4.665-5.869-5.827q-.612-.638-1.151-.843-.54-.225-1.43-.225H38.958q-2.488 0-3.714-1.255-1.226-1.256-1.226-3.728V41.643q0-2.454 1.226-3.71t3.714-1.255h23.978q2.508 0 3.733 1.255 1.208 1.256 1.208 3.71v14.314q0 2.472-1.207 3.728-1.226 1.255-3.734 1.255h-2.711q-.818 0-1.208.375-.39.356-.39 1.236z"
    ></path>
    <path
      fill="#E95D11"
      fillRule="evenodd"
      d="M59.414 49.569a.667.667 0 0 1 .949 0l2.893 2.918 2.215-2.234-2.893-2.919a3.78 3.78 0 0 0-5.38 0l-1.31 1.323a.667.667 0 0 1-.95 0l-1.31-1.322a3.78 3.78 0 0 0-5.38 0l-1.31 1.322a.667.667 0 0 1-.95 0l-1.31-1.322a3.78 3.78 0 0 0-5.38 0l-2.892 2.918 2.215 2.234 2.892-2.918a.667.667 0 0 1 .95 0l1.31 1.322a3.78 3.78 0 0 0 5.38 0l1.31-1.322a.667.667 0 0 1 .95 0l1.31 1.322a3.78 3.78 0 0 0 5.38 0z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#1D1D1D"
      fillRule="evenodd"
      d="M19.9 52.466q.804.903 2.202.904.974 0 1.82-.484.81-.451 1.895-1.376v-5.886l-2.572 2.512V42.21q0-.987-.445-1.387-.444-.42-1.376-.42h-3.091q-2.86 0-4.256-1.408-1.376-1.409-1.376-4.183V18.756q0-2.753 1.376-4.161 1.397-1.408 4.256-1.408h27.334q2.838 0 4.235 1.408t1.398 4.16v9.554H56v-9.742q0-3.153-1.207-5.401a8.1 8.1 0 0 0-3.451-3.447q-2.244-1.22-5.463-1.219H18.121q-3.197 0-5.463 1.219a8.2 8.2 0 0 0-3.472 3.447Q8 15.416 8 18.566v16.456q0 3.153 1.207 5.402 1.228 2.249 3.451 3.446t5.23 1.198h1.228v4.981q0 1.513.783 2.417"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default IllustrationChat;
